import { Title } from 'components';
import React from 'react';
import { ProductRecap } from 'services/order/order.type';
import { ItemContainer } from './CartItem.style';

export type CartItemProps = ProductRecap;

const CartItem: React.FunctionComponent<CartItemProps> = ({ label, totalPrice }) => {
    return (
        <ItemContainer>
            <Title noTranslation text={label} type="medium" />
            <Title
                type="normal"
                isCurrency
                text={totalPrice.totalInclTax}
                currency="EUR"
                weight="light"
            />
        </ItemContainer>
    );
};

export default CartItem;
